import React, { useEffect, useState } from "react";
import toast, { Toaster } from 'react-hot-toast';
import { useCreateEnquiryApiMutation } from "../../../redux/API/ContactApi";

const EnquiryForm = ({ pid }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    travellers: "",
    adults: 0,
    children: 0,
    infants: 0,
    id : pid,
    message: "",
  });
  
  const [createEnquiry] = useCreateEnquiryApiMutation();
  const [errors, setErrors] = useState({});
  const [totalError, setTotalError] = useState(""); // this to change
  const [lastChangedField, setLastChangedField] = useState(null);


  useEffect(() => {
    // Update packageId when pid prop changes
    setFormData((prev) => ({ ...prev, packageId: pid }));
  }, [pid]);


  const validateForm = () => {
    const newErrors = {};
    const nameRegex = /^[a-zA-Z\s]*$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10}$/;

    // Name validation
    if (!formData.name.match(nameRegex)) {
      newErrors.name = "Name should contain only letters";
    }

    // Email validation
    if (!formData.email.match(emailRegex)) {
      newErrors.email = "Invalid email address";
    }

    // Phone validation
    if (!formData.phone.match(phoneRegex)) {
      newErrors.phone = "Invalid phone number (10 digits required)";
    }

    // Travellers validation
    if (formData.travellers < 1) {
      newErrors.travellers = "Number of travelers must be at least 1";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const validateTotal = () => {
    const totalPeople = formData.adults + formData.children + formData.infants;
    const isValid = totalPeople <= formData.travellers;

    if (!isValid && lastChangedField) {
      setErrors(prev => ({
        ...prev,
        [lastChangedField]: "Total exceeds number of travelers"
      }));
    } else if (isValid && lastChangedField) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[lastChangedField];
        return newErrors;
      });
    }
    return isValid;

  };

  const handleIncrement = (field) => {
    setLastChangedField(field);
    setFormData(prev => ({
      ...prev,
      [field]: prev[field] + 1
    }));
  };

  const handleDecrement = (field) => {
    setLastChangedField(field);
    setFormData(prev => ({
      ...prev,
      [field]: Math.max(0, prev[field] - 1)
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLastChangedField(name);

    if (name === "phone") {
      const sanitizedValue = value.replace(/\D/g, '').slice(0, 10);
      setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
      return;
    }

    if (name === "name" && !/^[a-zA-Z\s]*$/.test(value)) return;

    setFormData(prev => ({
      ...prev,
      [name]: name === "travellers" ? Math.max(0, parseInt(value) || 0) : value
    }));
  };

  
  const handleSubmit = async (e) => {
    
    e.preventDefault();
    
    if (!validateForm() || !validateTotal()) return;

    try {
      const response = await createEnquiry(formData).unwrap();
      console.log("Enquiry Submitted Successfully:", response);
      toast.success("Enquiry submitted successfully!");
      setFormData({
        name: "",
        email: "",
        phone: "",
        travellers: 0,
        adults: 0,
        children: 0,
        infants: 0,
        id: pid,
        message: "",
      })
    } catch (error) {
      console.error("Error submitting enquiry:", error);
      toast.error("Failed to submit enquiry.");
    }
  };
  
  const totalPeople = formData.adults + formData.children + formData.infants;
  const plusDisabled = totalPeople >= formData.travellers;
  

  useEffect(() => {
    validateTotal();
  }, [formData.adults, formData.children, formData.infants, formData.travellers]);

  return (
    <>
      <Toaster position='top-right' />


      <form onSubmit={handleSubmit} className="bg-white p-3 rounded-3 border mx-auto">

        {/* Name Field */}
        <div className="mb-2">
          <input
            type="text"
            className="form-control"
            placeholder="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
         {errors.name && <div className="text-danger small">{errors.name}</div>}

        </div>

        {/* Email Field */}
        <div className="mb-2">
          <input
            type="email"
            className="form-control"
            placeholder="eg@gmail.com"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
        {errors.email && <div className="text-danger small">{errors.email}</div>}

        </div>

        {/* Phone & Travellers */}
        <div className="mb-2">
          <input
            type="tel"
            className="form-control"
            maxLength={10}
            placeholder="+91 0000000000"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
          />
         {errors.phone && <div className="text-danger small">{errors.phone}</div>}

        </div>
        <div className="mb-2">
          <input
            type="number"
            className="form-control"
            placeholder="No. of Travellers"
            name="travellers"
            value={formData.travellers}
            onChange={handleChange}
            min="1"

          />
         {errors.travellers && <div className="text-danger small">{errors.travellers}</div>}

        </div>


        {/* Number of Adults */}
        
        <div className="form-group text-center pb-2 border-bottom mb-2">
          <label className=" mb-1" style= {{fontSize: "12px"}}>No. Of Adults</label>
          <div className="d-flex align-items-center justify-content-between">
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary minus"
              onClick={() => handleDecrement("adults")}
            >
              -
            </button>
            <input
              className="form-control text-center w-75 border-0"
              name="adults"
              type="number"
              value={formData.adults}
              // onChange={handleChange}
              readOnly
              min="0"

            />
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary minus"
              onClick={() => handleIncrement("adults")}
              disabled={plusDisabled}

            >
              +
            </button>
          </div>
          {errors.adults && <div className="text-danger small">{errors.adults}</div>}

        </div>


        
        {/* Number of Children */}
        
        <div className="form-group text-center pb-2 border-bottom mb-2">
          <label className=" mb-1" style= {{fontSize: "12px"}}>No. Of Children</label>
          <div className="d-flex align-items-center justify-content-between">
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary minus"
              onClick={() => handleDecrement("children")}
            >
              -
            </button>
            <input
              className="form-control text-center w-75 border-0"
              name="children"
              type="number"
              value={formData.children}
              // onChange={handleChange}
              readOnly
              min="0"
            />
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary minus"
              onClick={() => handleIncrement("children")}
              disabled={plusDisabled}
            >
              +
            </button>
          </div>
        {errors.children && <div className="text-danger small">{errors.children}</div>}
        </div>

        


        {/* Number of Infants */}
        
        <div className="form-group text-center pb-2 border-bottom mb-2">
          <label className=" mb-1" style= {{fontSize: "12px"}}>No. Of Infants</label>
          <div className="d-flex align-items-center justify-content-between">
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary minus"
              onClick={() => handleDecrement("infants")}
            >
              -
            </button>
            <input
              className="form-control text-center w-75 border-0"
              name="infants"
              type="number"
              value={formData.infants}
              // onChange={handleChange}
              readOnly
              min="0"

            />
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary minus"
              onClick={() => handleIncrement("infants")}
              disabled={plusDisabled}

            >
              +
            </button>
            </div>
            {errors.infants && <div className="text-danger small">{errors.infants}</div>}

            </div>
           
         {/* Message Textarea */}
        <div className="mb-2">
          <textarea
            className="form-control"
            placeholder="Hello"
            name="message"
            value={formData.message}
            onChange={handleChange}
          />
        </div>

        {/* Submit Button */}
        <div className="col-12 text-center">
          <button type="submit" className="btn mt-2 text-white fw-bold" style={{ backgroundColor: "var(--color2)", borderRadius: "50px", width: "65%", fontSize:"12px" }}>
            Send Query
          </button>
        </div>
      </form>
    </>
  );
};

export default EnquiryForm;
